import React from "react";
import { Modal, ModalBody, Card, CardBody, Row, Col } from "reactstrap";
import ChartImage from "../../../../assets/images/CHPT/chart.png";
import BoardRoom from "../../../../assets/images/charty-party/BoardRoom-old.png";

import ChartParty from "../../../../assets/images/CHPT/charity-party-large.png";
import LargeVector from "../../../../assets/images/CHPT/largeVector.png";
import ChartyPartyCards from "../../../../assets/images/CHPT/chartyParty.png";
import Vector from "../../../../assets/images/CHPT/waveVector.png";
import Trophies from "../../../../assets/images/CHPT/trophies.png";
import ResultBanner from "../../../../assets/images/CHPT/result-banner.png";
import Tenor from "../../../../assets/images/CHPT/tenor.png";
import { compose } from "redux";
import { withSocket } from "../../../../socket/context";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import _ from "lodash";

const ResultPage = (props) => {
  const gameState = _.get(props, "gameReducer.roomObj.game_state");
  let active_player = _.get(gameState, "active_player");
  const playerQueue = _.get(gameState, "player_queue");
  const wingif = _.get(gameState, "game_outputs.win_url");
  const status = _.get(gameState, "status");
  const prompt = _.get(gameState, "prompt");
  const congrats = _.get(props, "paramsReducer.gameObj.screens.chpt.congrats");
  let users = _.get(props, "gameReducer.roomObj.users");
  let playedCards = _.get(gameState, "played_cards");
  const winner = _.filter(playedCards, (item) => {
    if (item.winner) {
      return item;
    }
  })[0];
  const winnerUserDetails = users.filter(
    (user) => user.player_id === winner.player_id
  )[0];
  let playerName = winnerUserDetails.display_name;

  let nextJudgeUserDetails = active_player;
  if (active_player < playerQueue.length) {
    nextJudgeUserDetails = users.filter(
      (user) => user.player_id === active_player + 1
    )[0];
  } else if (active_player === playerQueue.length) {
    nextJudgeUserDetails = users.filter(
      (user) => user.player_id === playerQueue[0]
    )[0];
  }

  return (
    <>
      {status === "Result" ? (
        <div className="charity-modal charity-result-modal">
          <div className="charity-result-modal-container">
            <div className="text-center">
              <div className="charity-result-wrapper">
                <h2>{congrats}</h2>
                {/* <img src={wingif} alt="" className="result-player-image" /> */}
              </div>
            </div>
            <div className="result-row">
              <Row className="mx-0">
                <Col md={3} className="d-flex justify-content-end">
                  <div className="charity-result-cards">
                    <div className="chpt-result-card">
                      <div className="img-container">
                        <img src={winner.card.url} />
                        {/* <div className="d-flex align-items-center px-1 justify-content-between">
                <p className="mb-0 card-text">SUPER FUNNY Bit </p>
                <div className="d-flex flex-column ">
                  <p className="y-text mb-0">Y</p>
                  <img src={LargeVector} alt="vector" />
                </div>
              </div>
              <img src={ChartParty} alt="charty-party" className="mt-3" /> */}
                      </div>
                    </div>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="chart-image">
                    <img src={prompt.url} at="" />
                  </div>
                </Col>
                <Col md={3} className="d-flex justify-content-start">
                  <div className="chpt-winner-profile">
                    <div className="trophie-image-wrapper">
                      <img src={Trophies} />
                      <div className="score-name">
                        <img src={ResultBanner} />
                        <p>
                          Scored<span className="chpt-font">!</span>
                        </p>
                      </div>
                    </div>
                    <div className="charity-player">
                      <img src={winnerUserDetails.profile_image} alt="" />
                      <h3>{playerName}</h3>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
            <Row className="mx-0">
              <Col
                // md={3}
                // className="pt-4 mt-lg-2 d-flex justify-content-start"
                className="d-flex justify-content-start"
                md={{ size: 3, offset: 9 }}
              >
                <div className="charity-next-judge">
                  <img
                    src={nextJudgeUserDetails?.profile_image}
                    alt=""
                    className="judge-image"
                  />
                  <div className="next-judge-name">
                    <h4 className="mb-0">next chart czar</h4>
                    <h3 className="mb-0">
                      {nextJudgeUserDetails?.display_name}
                    </h3>
                  </div>
                  <img src={Vector} className="graph" />
                </div>
              </Col>
            </Row>
          </div>
        </div>
      ) : (
        <div className="charity-winner-modal">
          {/* <div className="text-center">
              <h2>{congrats}</h2>
              <img src={wingif} alt="" className="result-player-image" />
            </div> */}
          <div className="over-div-wrapper">
            <div className="container">
              <div className="trophie-image-wrapper">
                <img src={Trophies} />
              </div>
              <div className="score-name">
                <img src={ResultBanner} />
                <p>
                  Winner<span className="chpt-font">!</span>
                </p>
              </div>
              <div className="over-div">
                <div className="charity-player">
                  <img src={winnerUserDetails.profile_image} alt="" />
                  <h3>{playerName}</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer
});

const mapDispatchToProps = (dispatch) => {
  return {};
};
export default compose(
  withRouter,
  withSocket,
  connect(mapStateToProps, mapDispatchToProps)
)(ResultPage);
